// extracted by mini-css-extract-plugin
module.exports = {"container":"footer_container__a7Ksf","footerText":"footer_footerText__3-u_n","socials":"footer_socials__2f9Ii","button":"footer_button__3s60-"};